// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Fashion_wrapper__jB2uX","title-container":"Fashion_title-container__3RAf5"};